// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset default styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Additional custom styles */
.App {
  text-align: center;
}

/* Ensure the app takes full height */
html, body, #root {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,YAAY;AACd","sourcesContent":["/* Reset default styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Additional custom styles */\n.App {\n  text-align: center;\n}\n\n/* Ensure the app takes full height */\nhtml, body, #root {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
